import classNames from 'classnames';
import { Button } from 'components/button';
import {
  useScommettiSingolaMultiplaVirtualMutation,
  useScommettiSistemaVirtualMutation,
} from 'features/api/virtualApiSlice';
import { useIsSaldoGiocabile } from 'features/carrello/hooks';
import { setIsOpenLoginModalValue } from 'features/modal/modalSlice';
import { useInternalSession } from 'hooks';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import { isClientSide, isHappybetSite } from 'utility/constant';
import { gtag } from 'utility/functions';
import {
  selectErroreInserimento,
  selectIsScommettibile,
  selectIsSistema,
  selectTicket,
} from '../../virtualTicketSelectors';
import styles from './VirtualTicketActionScommetti.module.scss';

export type VirtualTicketActionScommettiProps = {
  btnClassName?: string;
};

export const VirtualTicketActionScommetti = ({ btnClassName }: VirtualTicketActionScommettiProps) => {
  const [scommettiButtonLabel] = useGetLabelsByKeys(['vendita-action-scommetti-button'])!;
  const { asPath } = useRouter();

  const { isAuthenticated } = useInternalSession();

  const ticket = useTypedSelector(selectTicket);
  const isScommettibile = useTypedSelector(selectIsScommettibile);
  const isSistema = useTypedSelector(selectIsSistema);
  const erroreInserimento = useTypedSelector(selectErroreInserimento);

  const [scommettiSingolaMultiplaVirtual, { isLoading: isLoadingSingolaMultipla }] =
    useScommettiSingolaMultiplaVirtualMutation();
  const [scommettiSistemaVirtual, { isLoading: isLoadingSistema }] = useScommettiSistemaVirtualMutation();

  const isSaldoGiocabile = useIsSaldoGiocabile();
  const dispatch = useAppDispatch();

  const canBet = useMemo(
    () =>
      [isScommettibile, ticket?.errori?.length === 0, erroreInserimento === undefined, isSaldoGiocabile].every(
        Boolean
      ) &&
      (!isLoadingSingolaMultipla || !isLoadingSistema),
    [
      isScommettibile,
      ticket?.errori?.length,
      erroreInserimento,
      isSaldoGiocabile,
      isLoadingSingolaMultipla,
      isLoadingSistema,
    ]
  );

  const onScommetti = useCallback(async () => {
    if (!isAuthenticated) {
      dispatch(setIsOpenLoginModalValue(true));
      return;
    }
    if (canBet && ticket) {
      if (isClientSide) {
        gtag(
          {
            event: 'Bet Start',
            detail: 'Bet Start',
            section: asPath,
            eventCategory: 'Bet',
          },
          true,
          true
        );
        if (isHappybetSite) {
          //FACEBOOK PIXEL
          const { fbq } = window as any;
          if (typeof fbq === 'function') fbq('trackCustom', 'BetStart');
        }
      }
      const apiToCall = isSistema ? scommettiSistemaVirtual : scommettiSingolaMultiplaVirtual;
      apiToCall(ticket);
    }
  }, [
    canBet,
    ticket,
    asPath,
    isSistema,
    isAuthenticated,
    dispatch,
    scommettiSistemaVirtual,
    scommettiSingolaMultiplaVirtual,
  ]);

  const disableBtn = isAuthenticated && !canBet;

  return (
    <Button
      type="button"
      className={classNames(styles.button, btnClassName, { [styles.disable]: disableBtn })}
      disabled={disableBtn}
      size="medium"
      visualizationType={'primary'}
      onClick={() => onScommetti()}
    >
      {scommettiButtonLabel}
    </Button>
  );
};
